module.exports = __webpack_public_path__ + "static/media/golfer-1-a.e799d5f9.png";